import makeStyles from '@mui/styles/makeStyles'

const bp = 'sm'

const useStyles = makeStyles(theme => ({
  root: {
    marginBottom: '8px'
  },

  flexArea: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',

    [theme.breakpoints.down(bp)]: {}
  },

  buttonBase: {
    display: 'flex',
    alignItems: 'center',
    border: '1px solid #C6C6C6',
    borderRadius: '8px',
    boxSizing: 'border-box',
    padding: '5px 8px 6px 8px',
    background: '#F5F6F8',
    cursor: 'pointer',
    fontSize: theme.size.base,
    color: '#121212',
    userSelect: 'none',

    '& .icon': {
      marginRight: '8px'
    }
  },

  disabled: {
    cursor: 'default'
  },

  dropdown: {
    marginRight: '8px !important',

    '& .arrow': {
      marginLeft: '8px',
      height: '1rem',
      width: '1rem'
    }
  },

  menuPaper: {
    border: '1px solid #E5EAF1',
    borderRadius: '7px',
    boxSizing: 'border-box',
    boxShadow: '0px 20px 30px rgba(0, 0, 0, 0.15)',
    width: '140px'
  },

  menuList: {
    padding: '12px 0'
  },

  menuItem: {
    margin: '0 auto',
    borderRadius: '4px',
    width: 'calc(100% - 16px)',
    height: '32px',
    padding: '0',
    paddingLeft: '8px',
    fontSize: theme.size.base,
    color: '#3C425B',

    '&:not(:last-child)': {
      marginBottom: '4px'
    }
  },

  menuIcon: {
    color: '#404040'
  },

  label: {
    fontSize: theme.size.base,
    color: '#121212',
    userSelect: 'none'
  },

  switch: {
    marginLeft: '8px',

    [theme.breakpoints.down(bp)]: {}
  }
}))

export default useStyles
